import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import MetadataFilesSlider from '../../ui-parts/MetadataFilesSlider';
import useWebContext from '../../hooks/useWebContext';

/** MyMine Version2.0 ServiceLv2_2画面新規追加
 * ServiceLv2SubLv2DocumentsTabContents Component
 */
export const ServiceLv2SubLv2DocumentsTabContents = React.memo((
  props) => {

  const {
    visible,
    screenId,
    callbackFavorite,
    metadata,
    setIsLoading,
    isPc,
  } = props;

  const { controlSettings, messageList } = useWebContext(screenId);
  const [selectedSlideMetadataList, setSelectedSlideMetadataList] = React.useState([]);

  if (!visible) {
    return <></>
  }

  return (
    <Stack className='h-100' spacing={3}>
      <Box sx={{ bgcolor: '#eeeeee', minHeight: 520 }}>
        <Stack spacing={3} className='p-2' sx={{ minHeight: 350, flex: 1 }}>
          <MyMLabel sx={{ padding: '10px 0 0 30px', fontWeight: 'bold' }}>{controlSettings.LabelList.lblDocuments}</MyMLabel>
          {isPc &&  
            <MyMLabel sx={{ padding: '0 0 0 30px', margin: '0 !important' }}>{controlSettings.LabelList.lblFilterDescription}</MyMLabel>
          }
          <Box className='d-flex justify-content-center flex-fill align-items-center mt-0'>
            {metadata.BoxFileList.length === 0
              ? <MyMLabel>{messageList.MyM_MSG_I_0059}</MyMLabel>
              : <MetadataFilesSlider
                key={metadata.BoxFileList.map(x => x.FileId)}
                controlSettings={controlSettings}
                screenId={screenId}
                selectedSlideMetadataList={selectedSlideMetadataList}
                setSelectedSlideMetadataList={setSelectedSlideMetadataList}
                callbackFavorite={callbackFavorite}
                metadataId={metadata.MetadataId}
                fileList={metadata.BoxFileList}
                setIsLoading={setIsLoading}
              />
            }
          </Box>
        </Stack>
      </Box>

    </Stack>
  );
});